import { useEffect, type ReactNode } from "react";
import {
  bindThemeParamsCssVars,
  expandViewport,
  init,
  isTMA,
  miniAppReady,
  mountMiniAppSync,
  mountThemeParamsSync,
} from "@telegram-apps/sdk-react";
import { isTelegramWebApp } from "../lib/telegram.js";

interface TelegramSdkRootProps {
  children: ReactNode;
}

/** Initialise @telegram-apps/sdk-react when running inside Telegram. */
export function TelegramSdkRoot({ children }: TelegramSdkRootProps) {
  useEffect(() => {
    if (!isTelegramWebApp() && !isTMA()) return;

    try {
      init();
      mountMiniAppSync();
      mountThemeParamsSync();
      bindThemeParamsCssVars();
      miniAppReady();
      expandViewport();
    } catch {
      /* fallback: native WebApp bootstrap in AppShell */
    }
  }, []);

  return <>{children}</>;
}
